import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from 'app-components/flux/core';
import type { ReportConfigurationProps } from 'app-components/flux/report-configurations/reportConfigurationsTypes';

import * as actions from './reportConfigurationDefaultsActions';

const QcsSyncReportConfigurationDefaultsStoreFactory =
  resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<ReportConfigurationProps>();

const reportConfigurationDefaultsReducer = handleActions<
  resourceStoreTypes.QcsSyncResourceStore<ReportConfigurationProps>,
  | ReturnType<typeof actions.getReportConfigurationDefaults>
  | ReturnType<typeof actions.getReportConfigurationDefaultsSuccess>
  | ReturnType<typeof actions.getReportConfigurationDefaultsFailure>
>(
  {
    [actions.getReportConfigurationDefaults.type]: (state) => state.set('isLoading', true),
    [actions.getReportConfigurationDefaultsSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResources(state, data),
    [actions.getReportConfigurationDefaultsFailure.type]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  QcsSyncReportConfigurationDefaultsStoreFactory(),
);

export default reportConfigurationDefaultsReducer;
